export function promocodeNumber() {
    const codeNumber = document.querySelector('.__promo_code_number');
    if(!codeNumber) return;
    const number = codeNumber.dataset.number;
    const valueLength = number.split('').length;
    codeNumber.innerHTML = valueLength === 1 ? `0${number}`: `${number}`;
}